export const SalesforceFieldTypeEnum = {
    PICKLIST: 'picklist',
    STRING: 'string',
    TEXTAREA: 'textarea',
    DOUBLE: 'double',
    PHONE: 'phone',
    URL: 'url',
    CURRENCY: 'currency',
    INT: 'int',
    DATE: 'date',
    DATETIME: 'datetime',
    EMAIL: 'email',
    BOOLEAN: 'boolean'
};